exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-label{font-size:18px;display:block;margin-bottom:10px;text-align:center;text-transform:uppercase}.form-input{border-radius:4px;border:1px solid #ffa81d;background-color:#383d41;color:#ffa81d;padding:10px;display:block;width:100%}.form-input--inline{display:inline-block;width:auto;margin-bottom:0}", ""]);

// exports
